import {
  AspectRatio,
  Box,
  Flex,
  GridItem,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  useToast,
} from "@chakra-ui/react";
import { useContext, useEffect } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { AuthContext } from "~/App";
import { BlueButton } from "../Buttons";
import { UserPreviewFragment } from "../fragments.generated";
import { useRemoveUserMutation } from "./index.generated";

export const UserIcon = ({ user }: { user: UserPreviewFragment }) => {
  const { currentUserId } = useContext(AuthContext);

  return (
    <GridItem w="100%" position="relative" overflow={"hidden"}>
      <AspectRatio ratio={1}>
        <Box justifyContent={"center"} border="1px" borderColor="white">
          <AiOutlineUser color="white" size="60%" />
        </Box>
      </AspectRatio>
      <Flex justifyContent={"space-between"}>
        <UserNamePreveiew name={user.name} />
        {currentUserId !== user.id ? <UserMenu user={user} /> : null}
      </Flex>
    </GridItem>
  );
};

const UserNamePreveiew = ({ name }: { name: string }) => {
  const previewName = name.length > 13 ? name.substring(0, 12) + "..." : name;

  return (
    <Text
      color="white"
      fontWeight="bold"
      fontSize={15}
      mt={2}
      whiteSpace={"nowrap"}
    >
      {previewName}
    </Text>
  );
};

const UserMenu = ({ user }: { user: UserPreviewFragment }) => {
  return (
    <Menu>
      <MenuButton
        mt={1}
        as={IconButton}
        bgColor="#16181a"
        _hover={{ bgColor: "#16181a" }}
        _active={{ bgColor: "#16181a" }}
      >
        <BsThreeDotsVertical color="white" size={20} />
      </MenuButton>
      <MenuList>
        <RemoveUserMenu user={user} />
      </MenuList>
    </Menu>
  );
};

const RemoveUserMenu = ({ user }: { user: UserPreviewFragment }) => {
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [removeUserRes, removeUser] = useRemoveUserMutation();

  useEffect(() => {
    if (removeUserRes.data?.removeUser.error) {
      toast({
        title: "ユーザーの削除に失敗しました。",
        description: removeUserRes.data.removeUser.error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
    if (removeUserRes.data?.removeUser.user) {
      toast({
        title: "ユーザーの削除に成功しました。",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [removeUserRes.data]);

  return (
    <>
      <MenuItem onClick={onOpen}>ユーザーの削除</MenuItem>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>ユーザーの削除</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>以下のユーザーを削除します。本当によろしいですか？</Text>
            <Text>ユーザー名：{user.name}</Text>
          </ModalBody>

          <ModalFooter>
            <Flex>
              <BlueButton
                label={"削除"}
                onClick={() => {
                  removeUser({
                    input: { id: user.id },
                  });
                  onClose();
                }}
              />
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
